import React, { useState } from 'react';

import { ClickAwayListener, Tooltip } from '@mui/material';
import { withStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';
import { StyledLinkBlue } from '../../../components/StyledLink';

const CustomMoreActionClickedTooltip = withStyles({
   tooltip: {
      '&.MuiTooltip-tooltip': {
         backgroundColor: '#FFF',
         padding: 0,
         borderRadius: '6px',
         border: '1px solid rgba(0, 0, 0, 0.2)',
         fontFamily: "'Montserrat', san-serif",

         '& .MuiTooltip-arrow': {
            color: '#f7f7f7',

            '&:before': {
               border: '1px solid rgba(0, 0, 0, 0.25)',
            },
         },
      },
   },
})(Tooltip);

const MoreActionClickedTooltip = (props) => {
   const { t } = useTranslation();

   const [open, setOpen] = useState(false);

   const handleTooltipToggle = () => {
      setOpen(!open);
   };

   return (
      <ClickAwayListener onClickAway={() => setOpen(false)}>
         <div className='w-full overflow-hidden'>
            <CustomMoreActionClickedTooltip
               title={
                  <div className='rounded-md'>
                     <div className='px-5 py-3 text-[#6B7280] bg-[#F9FAFB] text-base rounded-t-md border-b'>{props.title}</div>
                     <div className='px-5 py-3 flex-col text-sm gap-2 text-[#6B7280] hidden'>
                        <StyledLinkBlue>{t('common.go-to-events')}</StyledLinkBlue>
                        <StyledLinkBlue>{t('common.go-to-leaves-and-holidays')}</StyledLinkBlue>
                     </div>
                  </div>
               }
               open={open}
               onClose={() => setOpen(false)}
               disableHoverListener
               disableFocusListener
               disableTouchListener
               arrow
            >
               <div onClick={handleTooltipToggle}>{props.children}</div>
            </CustomMoreActionClickedTooltip>
         </div>
      </ClickAwayListener>
   );
};

export default MoreActionClickedTooltip;
